import { DetailColumnFormat } from './ColumnsFormatters/DetailColumnFormat';

export const columns = (onDelete, onEye, canRemove) => [
	{
		dataField: 'id',
		text: 'Acciones',
		classes: 'text-center',
		headerClasses: 'text-center',
		style: { minWidth: '137px' },
		formatter: DetailColumnFormat,
		formatExtraData: {
			onDelete,
			onEye,
			canRemove,
		},
	},
	{
		dataField: 'id',
		text: 'No',
	},
	{
		dataField: 'numeroResolucion',
		text: 'Resolución/Recomen',
	},
	{
		dataField: 'sector',
		text: 'Representación',
	},
	{
		dataField: 'temaOrigen',
		text: 'Tema',
	},
	{
		dataField: 'numeroSesion',
		text: 'Sesión de Origen',
	},
	{
		dataField: 'responsables',
		text: 'Responsable',
	},
	{
		dataField: 'acompanantes',
		text: 'Acompañamiento',
	},
	{
		dataField: 'comite',
		text: 'Comité',
	},
	{
		dataField: 'periodicidad',
		text: 'Periodo',
	},
	{
		dataField: 'fechaLimite',
		text: 'Prox. Entrega',
	},
	{
		dataField: 'estatus',
		text: 'Estatus',
	},
];

export const defaultQuery = {
	organ: '',
	resolution: '',
	sesion: '',
	area_responsible: [],
	area_companion: [],
};

export const queryForm = (onResults, institutions = []) => [
	{
		label: 'Número de resolucion',
		name: 'resolution',
		type: 'text',
		isNumber: true,
		column: 6,
	},
	{
		label: 'Área Administrativa Responsable',
		name: 'area_responsible',
		type: 'dropdown',
		options: [...institutions],
		multiple: true,
		column: 6,
	},
	{
		label: 'Área Administrativa Acompañamiento',
		name: 'area_companion',
		type: 'dropdown',
		options: [...institutions],
		multiple: true,
		column: 6,
	},
	{
		label: 'Sesión',
		placeholder: 'Total de sesiones registradas',
		name: 'sesion',
		type: 'text',
		disabled: true,
		column: 6,
	},
	{
		type: 'inner-column',
		column: 6,
	},
	{
		label: 'Consultar',
		type: 'button',
		color: 'danger',
		column: 6,
		onClick: onResults,
		style: { width: '100%' },
	},
];

export const userTypeTabs = [
	{ value: 1, label: 'Consulta por Resolución/Recomendación' },
	{ value: 2, label: 'Consulta por Unidad Administrativa' },
	{ value: 3, label: 'Consulta por Sesión' },
];

export const filterTab1 = (organs = [], onConfirmFilter, onClear) => [
	{
		label: '*Órgano Colegiado',
		name: 'organ1',
		placeholder: 'Órgano Colegiado',
		type: 'dropdown',
		options: [...organs],
		column: 4,
	},
	{
		label: 'Número de Resolución/Recomendación',
		name: 'resolution',
		type: 'text',
		column: 4,
	},
	{
		label: 'Estatus',
		placeholder: 'Estatus',
		name: 'status1',
		type: 'dropdown',
		column: 2,
		options: [
			{ value: 'EP', text: 'En proceso' },
			{ value: 'AT', text: 'Atendida' },
		],
	},
	{
		label: 'Limpiar',
		name: 'Limpiar',
		color: 'primary',
		type: 'button',
		column: 1,
		onClick: onClear,
	},
	{
		label: 'Buscar',
		name: 'Buscar',
		color: 'light-primary',
		type: 'button',
		column: 1,
		onClick: onConfirmFilter,
	},
];
export const filterTab2 = (institutions, onConfirmFilter, onClear, organs = []) => [
	{
		label: '*Órgano Colegiado',
		name: 'organ2',
		placeholder: 'Órgano Colegiado',
		type: 'dropdown',
		column: 3,
		options: [...organs],
	},
	{
		label: '*Area Administrativa Responsable',
		name: 'institutionR',
		type: 'dropdown',
		column: 3,
		options: [...institutions],
	},
	{
		label: 'Area Administrativa Acompañamiento',
		name: 'institutionA',
		type: 'dropdown',
		column: 4,
		options: [...institutions],
	},
	{
		label: 'Estatus',
		name: 'status2',
		type: 'dropdown',
		options: [
			{ value: 'EP', text: 'En proceso' },
			{ value: 'AT', text: 'Atendida' },
		],
		column: 2,
	},
	{
		column: 10,
		type: 'line-break',
	},
	{
		label: 'Limpiar',
		name: 'Limpiar',
		color: 'primary',
		type: 'button',
		onClick: onClear,
		column: 1,
	},
	{
		label: 'Buscar',
		name: 'Buscar',
		color: 'light-primary',
		type: 'button',
		column: 1,
		//className: 'ml-lg-4',
		onClick: onConfirmFilter,
	},
];
export const filterTab3 = (sessions, onConfirmFilter, onClear, organs = []) => [
	{
		label: '*Órgano Colegiado',
		name: 'organ3',
		placeholder: 'Órgano Colegiado',
		type: 'dropdown',
		options: [...organs],
		column: 4,
	},
	{
		label: '*Número de Sesión',
		name: 'sessionTab3',
		type: 'dropdown',
		options: [...sessions],
		column: 4,
	},
	{
		label: 'Estatus',
		placeholder: 'Estatus',
		name: 'status3',
		type: 'dropdown',
		options: [
			{ value: 'EP', text: 'En proceso' },
			{ value: 'AT', text: 'Atendida' },
		],
		column: 2,
	},
	{
		label: 'Limpiar',
		name: 'Limpiar',
		color: 'primary',
		type: 'button',
		onClick: onClear,
		column: 1,
	},
	{
		label: 'Buscar',
		name: 'Buscar',
		color: 'light-primary',
		type: 'button',
		column: 1,
		onClick: onConfirmFilter,
	},
];

export const defaultFilter = {
	resolution: '',
	sessionTab2: '',
	sessionTab3: '',
	institutionR: '',
	institutionA: '',
	organ1: '',
	organ2: '',
	organ3: '',
	status1: '',
	status2: '',
	status3: '',
};
